import { NeoPropuesta } from './neoPropuesta';
import { NeoCargo } from './neoCargo';
export class NeoPropuestaIntermediario {
  constructor(
    public propuesta: NeoPropuesta,
    public cargos: NeoCargo[] = [],
    public idCliente: Number,
    public idSolicitud: String,
    public idUsuario: Number
  ) {}
}
